var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import PublicRoute from './PublicRoute';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import Loadable from 'react-loadable';
import MasterLoadingComponent from 'components/masterLoading/MasterLoadingComponent';
// - Async Components
var AsyncHome = Loadable({
    loader: function () { return import('containers/home'); },
    loading: MasterLoadingComponent,
});
var AsyncHomePub = Loadable({
    loader: function () { return import('containers/homePublic'); },
    loading: MasterLoadingComponent,
});
var AsyncSignup = Loadable({
    loader: function () { return import('containers/signup'); },
    loading: MasterLoadingComponent,
});
var AsyncEmailVerification = Loadable({
    loader: function () { return import('containers/emailVerification'); },
    loading: MasterLoadingComponent,
});
var AsyncResetPassword = Loadable({
    loader: function () { return import('containers/resetPassword'); },
    loading: MasterLoadingComponent,
});
var AsyncLogin = Loadable({
    loader: function () { return import('containers/login'); },
    loading: MasterLoadingComponent,
});
var AsyncSetting = Loadable({
    loader: function () { return import('containers/setting'); },
    loading: MasterLoadingComponent,
});
var AsyncPrivacy = Loadable({
    loader: function () { return import('containers/privacy'); },
    loading: MasterLoadingComponent,
});
var AsyncFront = Loadable({
    loader: function () { return import('containers/FrontPg'); },
    loading: MasterLoadingComponent,
});
var AsyncClothingType = Loadable({
    loader: function () { return import('containers/ClothingType'); },
    loading: MasterLoadingComponent,
});
var AsyncPeople = Loadable({
    loader: function () { return import('containers/people'); },
    loading: MasterLoadingComponent,
});
var AsyncProfile = Loadable({
    loader: function () { return import('containers/profile'); },
    loading: MasterLoadingComponent,
});
var AsyncPostPage = Loadable({
    loader: function () { return import('containers/postPage'); },
    loading: MasterLoadingComponent,
});
var AsyncCheckout = Loadable({
    loader: function () { return import('containers/Checkout'); },
    loading: MasterLoadingComponent,
});
var AsyncGuestCheckout = Loadable({
    loader: function () { return import('containers/Checkout_Public'); },
    loading: MasterLoadingComponent,
});
var StreamTest = Loadable({
    loader: function () { return import('containers/Stream2'); },
    loading: MasterLoadingComponent,
});
/**
 * Master router
 */
var MasterRouter = /** @class */ (function (_super) {
    __extends(MasterRouter, _super);
    function MasterRouter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MasterRouter.prototype.render = function () {
        var _a = this.props, enabled = _a.enabled, match = _a.match, data = _a.data;
        return (enabled ? (React.createElement(Switch, null,
            React.createElement(Route, { path: '/signup', component: AsyncSignup }),
            React.createElement(Route, { path: '/emailVerification', component: AsyncEmailVerification }),
            React.createElement(Route, { path: '/settings', component: AsyncSetting }),
            React.createElement(Route, { path: '/resetPassword', component: AsyncResetPassword }),
            React.createElement(Route, { path: '/test', component: StreamTest }),
            React.createElement(Route, { path: '/collection/:Type/', component: AsyncClothingType }),
            React.createElement(PublicRoute, { path: '/checkout', component: React.createElement(AsyncCheckout, null) }),
            React.createElement(PublicRoute, { path: '/GuestCheckout', component: React.createElement(AsyncGuestCheckout, null) }),
            React.createElement(Route, { path: '/login', component: AsyncHomePub }),
            React.createElement(PublicRoute, { path: '/signin', component: React.createElement(AsyncLogin, null) }),
            React.createElement(PublicRoute, { path: '/privacy', component: React.createElement(AsyncPrivacy, null) }),
            React.createElement(Route, { path: '/:userId/posts/:postId/:tag?', component: AsyncPostPage }),
            React.createElement(Route, { path: '/profile/:userId', component: AsyncProfile }),
            React.createElement(Route, { render: function () { return React.createElement(AsyncHome, { uid: data.uid }); } })))
            : '');
    };
    return MasterRouter;
}(Component));
export { MasterRouter };
export default withRouter(connect(null, null)(MasterRouter));



//////////////////
// WEBPACK FOOTER
// ./src/routes/MasterRouter.tsx
// module id = 403
// module chunks = 50